let config = {};
let enviroment = "";

if (window.location.href.indexOf("localhost") >= 0) {
	enviroment = "dev";
}
else if (window.location.href.indexOf("ec2-34-206-89-100.compute-1.amazonaws.com:9090") >= 0) {
	enviroment = "homolog";
}
else {
	enviroment = "prod";
}

//enviroment = "homolog";

switch (enviroment) {
	case "dev":
		config = {
			urls: {
				SIGNALR_HUB_URL: "http://localhost:52939/hubs/ecoaudit",
				API_URL_CONT: 	"http://localhost:64191/api/",
				API_URL_BASE: 	"http://localhost:52939/api/",
				API_URL_FISCAL: "http://localhost:51053/api/",
				API_URL_ECF: "http://localhost:57767/api/",
				API_URL_ECD: "http://localhost:5000/api/"
			}
		};

	break;

	case "prod":
		config = {
			urls: {
				SIGNALR_HUB_URL: "https://auditor-webservico.econeteditora.com.br/hubs/ecoaudit",
				API_URL_CONT:	"https://auditor-cont.econeteditora.com.br/api/",
				API_URL_BASE: 	"https://auditor-webservico.econeteditora.com.br/api/",
				API_URL_FISCAL: "https://auditor-fiscal.econeteditora.com.br/api/",
				API_URL_ECF: "https://auditor-ecf.econeteditora.com.br/api/",
				API_URL_ECD: "https://auditor-ecd.econeteditora.com.br/api/"
			}
		};

	break;

	case "hotfix":
		config = {
			urls: {
				SIGNALR_HUB_URL: "https://ecoauditbasewebserv-hotfix.us-east-1.elasticbeanstalk.com/hubs/ecoaudit",
				API_URL_CONT: 	"https://econetauditcont-hotfix.us-east-1.elasticbeanstalk.com/api/",
				API_URL_BASE: 	"https://ecoauditbasewebserv-hotfix.us-east-1.elasticbeanstalk.com/api/",
				API_URL_FISCAL: "https://econetauditservico-hotfix.us-east-1.elasticbeanstalk.com/api/",
				API_URL_ECF: "https://econetauditecf-hotfix.us-east-1.elasticbeanstalk.com/api/"
			}
		};

	break;

	case "homolog":
		config = {
			urls: {
				SIGNALR_HUB_URL: "http://ecoauditbasewebservico-homologacao.us-east-1.elasticbeanstalk.com/hubs/ecoaudit",
				API_URL_CONT:	"http://econetauditcont-homologacao.us-east-1.elasticbeanstalk.com/api/",
				API_URL_BASE:	"http://ecoauditbasewebservico-homologacao.us-east-1.elasticbeanstalk.com/api/",
				API_URL_FISCAL: "http://econetauditservico-homologacao.us-east-1.elasticbeanstalk.com/api/",
				API_URL_ECF: "http://econetauditecf-homol.us-east-1.elasticbeanstalk.com/api/",
				API_URL_ECD: "http://econetauditecd-homologacao.eba-iygutrhw.us-east-1.elasticbeanstalk.com/api/",
			}
		};

	break;
}
  
export default config;


// WEBPACK FOOTER //
// ./src/Util/config.js